import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';
import { Textfit } from 'react-textfit';

//var image;

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;

//used for smart allocation - refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = "";
var questionCounter = 0;

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function GenerateQuestion(q) {
  var question;
  var image;
  var questionAnswers = [];
  var time = "";
  var questionHTML = "";
  var parameters = q.image_parameter.split(",");//split parameters
  console.log(q);
  //check image object to determine if subitising subject
  if (q.image != "a b c" && q.image != "Objects" && q.image != "abc") {
    question = q.question_line_1;
    if (q.time_on_screen != "") {
      console.log("SET TIME");
      time = q.time_on_screen.substring(0, q.time_on_screen.length - 1);
    }
    var answerNumber = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));//generate answer
    //image = q.image + answerNumber + ".png";//image = imagename plus number such as "Emile2.png"
    image = q.image.toLowerCase() + answerNumber + ".png";
    var answers = [];
    answers.push(answerNumber);//add correct
    for (let i = 0; i < 3; i++) {//generate wrong
      var wrong = GenerateUniqueRandom(parseInt(parameters[1]), parseInt(parameters[2]) + 2, answers)//wrong is random range plus 1
      answers.push(wrong);
      questionAnswers.push({
        correct: false,
        value: wrong
      });
    }
    questionAnswers.push({
      correct: true,
      value: answerNumber
    });
  } else {
    //number bonds
    if (q.image == "a b c" || q.image == "abc") {
      console.log("number bonds");
      //set generated total number
      var total = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));
      question = q.question_line_1.replace("$", total);//set question line
      //generate number "a" = 1-total
      //number b = total - a
      //number c = random number that isnt a or b
      var a = GenerateRandom(1, total - 1);
      var b = total - a;
      var usedNumbers = [];
      usedNumbers.push(a);
      if (a != b) {
        usedNumbers.push(b);
      }
      console.log(total);
      console.log(usedNumbers);
      var c = GenerateUniqueRandom(1, total + 1, usedNumbers);
      //push right answer
      questionAnswers.push({
        correct: true,
        value: a + "," + b
      });
      questionAnswers.push({
        correct: false,
        value: b + "," + c
      });
      questionAnswers.push({
        correct: false,
        value: c + "," + a
      });
      //create html of numbers
      var numbers = []
      numbers.push(a, b, c);
      shuffleArray(numbers);
      questionHTML = "<div style='font-size:200px; text-shadow:3px 2px #000000;color:white'>" + numbers[0] + "  " + numbers[1] + "  " + numbers[2] + "</div>";
    }
    else {
      if (q.topic_key == "NSense8" || q.topic_key == "NSense9") {//addition & subtraction level 1
        var num1 = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));//$
        var numused = [];
        numused.push(num1);
        var num2 = GenerateUniqueRandom(parseInt(parameters[4]), parseInt(parameters[5]), numused);//%
        if (q.topic_key == "NSense9") {
          num2 = GenerateUniqueRandom(parseInt(parameters[4]), num1, numused);//%
        }
        question = q.question_line_1.replace("$", num1);//replace $ with question_line_1
        question = question.replace("%", num2);
        var answer;
        if (question.includes("+")) {//addition answer
          answer = num1 + num2;
        } else {
          answer = num1 - num2;
        }
        var numbersUsed = []
        numbersUsed.push(answer);
        //wrong one = $, wrong two = %, wrong 3 = a - b or 0 if lower OR IF minus then add
        questionAnswers.push({
          correct: false,
          value: num1
        });
        if (num2 != answer) {
          questionAnswers.push({
            correct: false,
            value: num2
          });
        } else {
          questionAnswers.push({
            correct: false,
            value: GenerateUniqueRandom(1, 9, numbersUsed)
          });
        }
        var wrong3 = num1 - num2;
        if (question.includes("+")) {
          if (wrong3 < 0) {
            wrong3 = num2 - num1;
          }
          if (wrong3 < 0) {
            wrong3 = 0;
          }
        } else {
          wrong3 = num1 + num2;
        }

        questionAnswers.push({
          correct: false,
          value: wrong3
        });
        questionAnswers.push({
          correct: true,
          value: answer
        });


      } else {//add sub level 2
        var num1 = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));//$
        var num2 = GenerateRandom(parseInt(parameters[4]), parseInt(parameters[5]));//%
        //sometimes it is % generated and sometimes it is ? generated, need to look into that
        if (q.topic_key == "NSense10") {
          question = q.question_line_1.replace("$", num1);
          answer = num2;
          question = question.replace("%", num1 + num2);
          var numbersUsed = []
          numbersUsed.push(answer);
          for (let i = 0; i < 3; i++) {
            var wrong = GenerateUniqueRandom(parseInt(parameters[1]), parseInt(parameters[2]), numbersUsed)
            questionAnswers.push({
              correct: false,
              value: wrong
            });
            numbersUsed.push(wrong);
          }
          questionAnswers.push({
            correct: true,
            value: answer
          });

        } else if (q.topic_key == "NSense11") {
          console.log("help");
          console.log(num1);
          num2 = GenerateRandom(parseInt(parameters[4]), num1);
          console.log(num2);
          question = q.question_line_1.replace("$", num1);
          question = question.replace("%", num2);
          var answer = num1 - num2;
          var numbersUsed = []
          numbersUsed.push(answer);
          for (let i = 0; i < 3; i++) {
            var wrong = GenerateUniqueRandom(parseInt(parameters[1]), parseInt(parameters[2]), numbersUsed)
            questionAnswers.push({
              correct: false,
              value: wrong
            });
            numbersUsed.push(wrong);
          }
          questionAnswers.push({
            correct: true,
            value: answer
          });
        }
      }
    }
  }

  shuffleArray(questionAnswers);

  let questionObj = {
    question: question,
    answers: questionAnswers,
    time: time,
    image: image,
    questionHTML: questionHTML,
    topic_id: q.topic_id
  };

  console.log(questionObj);
  return questionObj;
}

var hideImageStart = false;
var oldQuestion = undefined;

export default function Practice({ ...props }) {
  const [rimage, setrimage] = useState();
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [nofeedback, setNoFeedback] = useState([]);
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
const [waitTime, setWaitTime] = useState(-10);

var timer = -1;
if(props.timelimit > 0)
{
    timer = props.timelimit;
}
else
{
    timer = 60;
}

var questionMax = -1;
if(props.minimum > 0)
{
    questionMax = props.minimum;
}

//if question counter is higher than 3 then reset -refeed
if(questionCounter > 3){
      questionCounter = 0;
  }

  //Sets the question to a new one
  function newQuestion() {
        
        currQuestion = GenerateQuestion(questions[Math.floor(Math.random() * questions.length)]); 

        //Debugging
      /*
        console.log("tst: lastQ: " + lastQuestion);
        console.log("tst: currQ: " + currQuestion.question);
        console.log("tst: Counter: " + questionCounter);
        */
        //get refeed question
        var loop = true;
        if (questionCounter === 2 && refeedQuestions[0] != undefined) {
            repeating = true;
            questionCounter = 0;
            currQuestion = refeedQuestions[refeedQuestions.length - 1];
            loop = false;
        }
        else
        {
            //if current quesiton is same as the previous question then reloop -refeed  
         while(loop){
            if (currQuestion.question.toString() === lastQuestion.toString()) { 
             //   console.log("tst: I have looped!");
                currQuestion = GenerateQuestion(questions[Math.floor(Math.random() * questions.length)]); 
            }
            else{
               //console.log("tst: Good to go!");
               loop = false; 
               break;
		    }
		 }   
        } 
        NewImage();
        return currQuestion;
    }

  
  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
  function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastQuestion = "";
        console.log("RESET");
  }

  var hideImage = false;
  var timeout;


  var DelayImage = function (delay) {
    if(timeout != undefined){
      clearTimeout(timeout);
  }
    console.log("Hide image start:" + hideImageStart);
    console.log("Hide image:" + hideImage);
    if (hideImageStart == false) {
      hideImageStart = true;
      hideImage = false;
      console.log("Displaying image for " + delay);
      timeout = setTimeout(HideImage, delay * 1000);
    }
  }

  function HideImage() {
  console.log("why");
    hideImageStart = false;
    hideImage = true;
    setrimage(require('../../assets/NumberSense/Images/Empty.png'));
  }

  //filter button list
  let buttonList = [];
  if (currentQuestion.answers != undefined) {
    for (let i = 0; i < currentQuestion.answers.length; i++) {
      if (currentQuestion.answers[i].name)
        console.log("push")
    }
  }

  function NewImage() {
    if (currQuestion.image != undefined) {
      console.log(oldQuestion);
      console.log(currQuestion);
      oldQuestion = currQuestion;
      var currImage = currQuestion.image;
      var correctAnswerName;
      //gets correct answer name for testing
      for (let i = 0; i < currQuestion.answers.length; i++) {
        if (currQuestion.answers[i].correct == true)
          correctAnswerName = currQuestion.answers[i].value;
      }
      setrimage(require('../../assets/NumberSense/Images/Empty.png'));
      setrimage(require('../../assets/NumberSense/Images/' + currImage));
      //console.log(oldQuestion);
      //console.log(currentQuestion);
      //console.log(currentQuestion.time);
      if (hideImageStart == false && currQuestion.time != "") {
        //start timer thing if timer is a thing
        console.log("do delay thing");
        DelayImage(parseInt(currQuestion.time));
      }
    }
  }

  //Called on click
  async function checkResult(value, callback) {

  //set the current question to the last question -refeed
    questionCounter = questionCounter +1;
    lastQuestion = currQuestion.question;
    
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (value.correct == true) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
        //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
        if (repeating) {
            refeedQuestions.pop();
            repeating = false;
        }
        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
      };
      setNoFeedback([...nofeedback, result]);

        newQuestion();
      }
      //incorrect answer
      else {
          isCorrect = false;
          questionCounter = 0;
        //push question to refeed if user gets it wrong - refeed
        refeedQuestions.push(currQuestion);

        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }

      //Generates a new question
      //newQuestion();

    }
  }
  function FilteredAnswers() {
    return currQuestion.answers;
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else if (waitTime != -10){

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);


  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      var sample = newQuestion();
      currQuestion = sample;
      NewImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status === "OK") {
      setLoading(false);
    }
  }, [status]);

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
      comboNum = 4;
    var imageName = props.gameData.animation_path + "/combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    console.log("../../assets/" + imageName)

    return (require("../../assets/" + imageName))

  }

  console.log(currQuestion);

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionLimit={questionMax}
        onBack={() => {
        Reset();
        props.onBack();
        }}
        loading={loading}
        feedback={feedback}
        nofeedback={nofeedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
          Reset();
        }}
      >
        <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
          <Scale scaleTo={2220}>
            <Body>
              <div style={{ width: "80%" }}>
                {currQuestion !== undefined ? (


                  <Container>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <Question
                        type="text"
                        disabled
                        value={
                          currQuestion.question !== undefined
                            ? currQuestion.question.replace("$", "?")
                            : ""
                        }
                      ><Textfit mode="single" style={{ height: "100%" }} > {currQuestion.question}</Textfit></Question>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
                      {currQuestion.image != "" && currQuestion.questionHTML == "" ? (
                        <img src={rimage}></img>
                        /*<img src = {image} className ={style.geoImg} filter = {hue-rotate(60deg);}></img>*/
                      ) : (
                          <div></div>
                        )}
                      {currQuestion.questionHTML != "" ? (
                        <DynamicStyle>
                          <div dangerouslySetInnerHTML={{ __html: currQuestion.questionHTML }}></div>
                        </DynamicStyle>
                      ) :
                        (
                          <div></div>
                        )}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between"
                      }}
                    >
                      {showColouredFeedback == false && currQuestion.answers !== undefined &&
                        currQuestion.answers.map(answer => (
                          <Button
                            value={<div dangerouslySetInnerHTML={answer.value} />}
                            style={{ flex: 1, margin: "20px" }}
                            onClick={() => checkResult(answer, true)}
                          >
                            <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                          </Button>
                        ))}

                      {showColouredFeedback == true && currQuestion.answers !== undefined &&
                        currQuestion.answers.map(answer => (
                          <Button
                            value={<div dangerouslySetInnerHTML={answer.value} />}
                            style={{ flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                          >
                            <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                          </Button>
                        ))}
                    </div>
                  </Container>

                ) : <h1>help</h1>}
              </div>
              <Combo>
                <span style={{ fontSize: "50px" }}>{combo}</span>
                <span style={{ fontSize: "20px" }}>COMBO</span>
              </Combo>
            </Body>
          </Scale>
        </div>
      </PracticeGame>
    </>
  );
}

const Body = styled.div`
            width: 100%;
            height: 100%;
  background-image: url("${props => props.gameBackground}");
            background-size: cover;
            background-position: 0px -1px;
            display: flex;
            justify-content: center;
            padding-top: 100px;
          `;

const Result = styled.div`
            width: 100%;
            height: 100%;
            font-size: 5em;
            text-align: center;
            border: solid 2px #683d8c;
          `;

const Combo = styled.div`
            background: #4391bb;
            width: 120px;
            height: 120px;
            border-radius: 75px;
            border: solid #204b7b 4px;
            display: flex;
            flex-direction: column;
            text-align: center;
            color: #fff;
            justify-content: center;
            font-weight: 600;
            margin-left: 50px;
          `;

const Container = styled.div`
            width:100%;
            height:95%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom:100px;
          `;

const Question = styled.div`
            background: #FFF;
            user-select: none;
            width: 150%;
            height: 120px;
            line-height: 90px;
            font-size: 4em;
            margin: 15px 25px;
            text-align: center;
            font-weight: 600;
            border: none;
            border-radius: 10px;
          `;

const Button = styled.div`
            text-align: center;
            width: 10%;
            height: 150px;
            line-height: 100px;
            font-size: 4em;
            margin: 5px;
            color: #fff;
            user-select: none;
            background: rgb(234, 146, 19);
            background: linear-gradient(
              0deg,
              rgba(234, 146, 19, 1) 0%,
              rgba(255, 186, 32, 1) 100%
            );
            border: 2px solid #e88f12;
            padding: 0.5em;
            box-sizing: border-box;
            border-radius: 0.25em;
            cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
        font - size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
  }
`;

const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
  position: realtive;
  top: 35%;
  //left: -15%;
  //width: 100%
  //text-align: center
  font-size 2em;
  //50%
`;